import React, { Component, lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPopup from './container/AutoshipV2/ErrorPopup';
import CheckoutWarningModal from './container/AutoshipV2/CheckoutWarningModal';
import {
  HashRouter as Router,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { default as autoshipStore } from './autoshipState/store.client';
import ThemeProvider from '@mui/system/ThemeProvider';
import theme from './container/AutoshipV2/theme';
import UnsavedChangesWarning from './container/AutoshipV2/UnsavedChangesWarning';
import { getCheckoutOrderManager } from 'cart-ui';
import Snackbar from './container/AutoshipV2/Snackbar';
import ManageCartProvider from './autoshipState/useManageCart/ManageCartProvider';

const CartPageContainer = lazy(() => import('./container/CartPageContainer'));
const CartV2 = lazy(() => import('./container/CartV2'));
const EditItems = lazy(() => import('./container/EditItems'));
const AutoshipList = lazy(() => import('./AutoshipList'));
const Autoship = lazy(() => import('./container/AutoshipV2'));
const OrderHistory = lazy(() => import('./OrderHistory'));
const PaymentPageContainer = lazy(
  () => import('./container/PaymentPageContainer')
);

interface Props {}

interface State {
  orderManager: any;
  loading: boolean;
}

class Root extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { orderManager: null, loading: true };
  }

  public componentDidMount() {
    getCheckoutOrderManager().then((orderManager) => {
      this.setState({ orderManager, loading: false });
    });
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  public render() {
    return (
      <Provider store={autoshipStore}>
        <ThemeProvider theme={theme}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                justifyContent: 'center',
                alignItems: 'center',
                margin: 'auto',
                width: '-webkit-fill-available',
                position: 'sticky',
                top: 0,
                zIndex: 1000,
              }}
            >
              <CheckoutWarningModal />
              <ErrorPopup />
            </div>

            <ErrorBoundary
              fallbackRender={() => (
                <p
                  style={{
                    margin: '10px auto',
                    color: 'red',
                    textAlign: 'center',
                  }}
                >
                  Oops! Something went wrong. Please refresh the page or contact
                  support if the error persists.
                </p>
              )}
            >
              <UnsavedChangesWarning />
              <Snackbar />
              <div className='cart-ui' style={{ width: '100%' }}>
                {this.state.orderManager !== null && (
                  <div>
                    <Router>
                      <Switch>
                        <Redirect exact from='/' to='/my-cartv2' />
                        <Redirect exact from='/my-cart' to='/my-cartv2' />
                        {/* <Redirect exact from="/payment" to="/my-cartv2" /> */}
                        <Route
                          exact
                          path='/order-preview' // keeping for now, but cannot be accessed by users
                          render={() => (
                            <Suspense fallback={<div />}>
                              <CartPageContainer
                                orderManager={this.state.orderManager}
                              />
                            </Suspense>
                          )}
                        />
                        <Route
                          exact
                          path='/autoship-list'
                          render={() => (
                            <Suspense fallback={<div />}>
                              <AutoshipList />
                            </Suspense>
                          )}
                        />

                        <Route
                          exact
                          path='/autoship'
                          render={() => (
                            <Suspense fallback={<div />}>
                              <Autoship />
                            </Suspense>
                          )}
                        />

                        <Route
                          exact
                          path='/order-history'
                          render={() => (
                            <Suspense fallback={<div />}>
                              <OrderHistory />
                            </Suspense>
                          )}
                        />

                        <Route
                          exact
                          path='/payment'
                          render={() => (
                            <Suspense fallback={<div />}>
                              <PaymentPageContainer
                                orderManager={this.state.orderManager}
                              />
                            </Suspense>
                          )}
                        />
                        <ManageCartProvider>
                          <Route
                            exact
                            path='/my-cartv2'
                            render={() => (
                              <Suspense fallback={<div />}>
                                <CartV2 />
                              </Suspense>
                            )}
                          />

                          <Route
                            exact
                            path='/items'
                            render={() => (
                              <Suspense fallback={<div />}>
                                <EditItems
                                  cartManager={this.state.orderManager}
                                />
                              </Suspense>
                            )}
                          />
                        </ManageCartProvider>
                      </Switch>
                    </Router>
                  </div>
                )}
              </div>
            </ErrorBoundary>
          </div>
        </ThemeProvider>
      </Provider>
    );
  }
}

export default Root;
